<template>
    <relatorio-risco objetivo="evasao" titulo="RELATÓRIO DE RISCO DE EVASÃO"></relatorio-risco>
</template>

<script>
import RelatorioRisco from '@/components/relatorio/shared/relatorio-risco'

// BLOCO K — item 139. Só fixa o objetivo; a lógica vive no componente compartilhado.
export default {
    name: 'RelatorioRiscoEvasao',
    components: { RelatorioRisco }
}
</script>
